import { createShader, colorUniform } from "./ShaderBase.js";

export const auroraShader = createShader({
  customizable: [
    { uniform: "uColorSky", label: "Sky", default: "#0a0a1a" },
    { uniform: "uColorGlow", label: "Glow", default: "#00ff88" },
  ],

  uniforms: {
    uPixelSize: { value: 12.0 },
    uScale: { value: 0.5 },
    uSpeed: { value: 0.2 },
    uColorSky: colorUniform("#0a0a1a"),
    uColorGlow: colorUniform("#00ff88"),
    uColorAccent: colorUniform("#8844ff"),
    uColorHighlight: colorUniform("#00ffcc"),
  },

  fragmentUniforms: `
    uniform vec3 uColorSky;
    uniform vec3 uColorGlow;
    uniform vec3 uColorAccent;
    uniform vec3 uColorHighlight;
  `,

  fragmentBody: `
    // Dark sky base
    vec3 color = uColorSky;

    // World-space 3D position for consistent look across all surfaces
    vec3 worldPos = pixelatedPos;

    // Flowing curtain effect using all 3 dimensions
    float curtain1 = snoise(vec3(
      worldPos.x * 0.3 + worldPos.z * 0.2 + uTime * uSpeed * 0.2,
      worldPos.y * 0.15 + sin((worldPos.x + worldPos.z) * 0.1 + uTime * uSpeed) * 2.0,
      uTime * uSpeed * 0.1
    ));

    float curtain2 = snoise(vec3(
      worldPos.x * 0.2 + worldPos.z * 0.15 - uTime * uSpeed * 0.15,
      worldPos.y * 0.1 + sin((worldPos.x + worldPos.z) * 0.08 + uTime * uSpeed * 0.8) * 2.5,
      uTime * uSpeed * 0.08 + 50.0
    ));

    float curtain3 = snoise(vec3(
      worldPos.x * 0.25 + worldPos.z * 0.18 + uTime * uSpeed * 0.1,
      worldPos.y * 0.12 + sin((worldPos.x + worldPos.z) * 0.12 + uTime * uSpeed * 1.2) * 1.5,
      uTime * uSpeed * 0.12 + 100.0
    ));

    // Combine curtains
    float aurora1 = (curtain1 + 1.0) * 0.5;
    float aurora2 = (curtain2 + 1.0) * 0.5;
    float aurora3 = (curtain3 + 1.0) * 0.5;

    // Layer the colors
    aurora1 = smoothstep(0.3, 0.7, aurora1);
    aurora2 = smoothstep(0.35, 0.75, aurora2);
    aurora3 = smoothstep(0.4, 0.8, aurora3);

    // Add glow colors in layers
    color = mix(color, uColorGlow * 0.6, aurora1 * 0.5);
    color = mix(color, uColorAccent * 0.7, aurora2 * 0.4);
    color = mix(color, uColorHighlight * 0.8, aurora3 * 0.3);

    // Subtle shimmer
    float shimmer = snoise(worldPos * 3.0 + vec3(uTime * uSpeed * 0.5));
    shimmer = (shimmer + 1.0) * 0.5;
    float shimmerMask = max(aurora1, max(aurora2, aurora3));
    color += vec3(0.05, 0.1, 0.08) * shimmer * shimmerMask;

    gl_FragColor = vec4(color, 1.0);
  `,
});
